import GroupedMainActions, {
  mapDispatchToProps,
  mapStateToProps,
} from '../../../../../pages/vip/features/grouped-main-actions/index';

export default GroupedMainActions;

export { mapDispatchToProps, mapStateToProps };
